import { Input } from '@myua/kit';
import { getSearchQuery } from '../selectors';
import { useSelector, useDispatch } from 'react-redux';
import * as sharingLinkActions from '../actions';
import { useState } from 'react';
import { useDebounce } from 'react-use';

export const Search = () => {
  const dispatch = useDispatch();

  const searchQuery = useSelector(getSearchQuery);
  const [value, setValue] = useState(searchQuery);

  useDebounce(
    () => {
      const newSearchQuery = value.trim();
      if (searchQuery !== newSearchQuery) {
        dispatch(sharingLinkActions.searchQueryChanged({ searchQuery: newSearchQuery }));
      }
    },
    500,
    [searchQuery, value],
  );

  return (
    <Input
      className="al-sharing-links-page-search"
      placeholder="Search by name, email, username"
      allowClear
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
};
